import { createFileRoute } from '@tanstack/react-router';

import { AiActionsPage } from '@/features/ai-actions/components/ai-actions-page';

export const Route = createFileRoute('/_app/crm/ai-actions/')({
  component: AiActionsPage,
});
